import React from 'react'
import { Typography } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'


const styles = theme => ({
  footer: {
    color: 'rgba(255,255,255,0.85)',
    textAlign: 'center',
    // Pull the copyright up onto the sand of the sea floor.
    marginTop: 'calc(-1 * min(5vw, 60px))',
    paddingBottom: '2vh',
    position: 'relative',
    textShadow: '0 1px 6px rgba(0,0,0,0.6)',
    pointerEvents: 'none',
    right: 0,
    left: 0,
  },
})


class Footer extends React.Component {

  render() {
    const { classes } = this.props
    return (
      <React.Fragment>
        <Typography component="p" variant="body1" className={classes.footer}>
          Copyright © {new Date().getFullYear()}
        </Typography>
      </React.Fragment>
    )
  }
}


export default withStyles(styles)(Footer)
